if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

connectedCallback() {
  super.connectedCallback();

  this.triggerOpen = this.dataset.triggerOpen;
  this.repeatOpen = this.dataset.repeatOpen;
  this.cookieName = 'sleektheme:popup';
  this.submissionFlag = 'sleektheme:popup-submitted';

  window.FoxTheme.DOMready(this.handleOpen.bind(this));

  if (localStorage.getItem(this.submissionFlag)) {
    this.showInfoPopup();
  }

  const couponButton = document.getElementById('Newsletter-coupon');
  if (couponButton) {
    couponButton.addEventListener('click', () => {
      const couponCode = document.getElementById('coupon').innerText;  
      navigator.clipboard.writeText('GATACA10'); 
      
    });
  }
}

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        // Check if the form was previously submitted
        if (localStorage.getItem(this.submissionFlag)) {
          this.showInfoPopup();
          return;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 30000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(() => {
  }).catch((err) => {
    console.error('Error copying text to clipboard', err);
  });
}

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }

    showInfoPopup() {
  if (document.getElementById('SubscriptionModal-sections--23615472238897__popup2')) {
    return; // Exit early if the popup is already shown
  }
        const infoPopup = document.createElement('div');
        infoPopup.innerHTML = `
          <subscription-popup id="SubscriptionModal-sections--23615472238897__popup2" class="drawer modal subscription-popup subscription-popup__image-left" shopify-design-mode="" data-trigger-open="delay" data-repeat-open="every_day" style="--modal-width: 88.0rem;" open="" active="">
    <div class="fixed-overlay" aria-controls="SubscriptionModal-sections--23615472238897__popup" aria-expanded="true"></div>
    <div class="drawer__inner blocks-radius">
      <button class="drawer__close-btn" id="close-copupon-popup" aria-controls="SubscriptionModal-sections--23615472238897__popup" aria-label="Close" aria-expanded="true">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--medium" fill="none" viewBox="0 0 24 24">
          <path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
<div class="drawer__body v-scrollable h-full">
        <div class="flex flex-wrap text-center"><div class="subscription-popup__image w-full media-wrapper loaded" style="--aspect-ratio: 1.0">
                <img src="//gataca.in/cdn/shop/files/when_d6878586-c343-49f3-846f-257548d37e9d.jpg?v=1734533377&amp;width=650" alt="" srcset="//gataca.in/cdn/shop/files/when_d6878586-c343-49f3-846f-257548d37e9d.jpg?v=1734533377&amp;width=375 375w, //gataca.in/cdn/shop/files/when_d6878586-c343-49f3-846f-257548d37e9d.jpg?v=1734533377&amp;width=420 420w" width="650" height="650" loading="lazy" fetchpriority="low" class="motion-reduce loaded" sizes="(min-width: 1024px) 420px,(min-width: 912px) 880px, calc(100vw - 3.2rem)" is="image-lazy">
              </div>
              <div class="subscription-popup__blocks w-full flex flex-col justify-center">

              <div class="coupon-container">
					<p>Subscribe to our list and get 10% Off</p>
					<div style="display: flex; justify-content: center; align-items: center;">
  						<div class="coupon-code" id="coupon">GATACA10</div>
						
					</div>
					
				</div>
              
                    <div class="subscription-popup__form">
                    <div class="newsletter-form newsletter-form__design-2">
                      <form accept-charset="UTF-8" class="contact-form" is="newsletter-form"><input id="NewsletterForm-Popup" type="hidden" name="contact[email]" class="form-control" value="" aria-required="true" autocorrect="off" autocapitalize="off" autocomplete="email" placeholder="Email" required="">
    <div class="newsletter-form__field-wrapper">
      <div class="form-field relative">
<button type="button" class="newsletter-form__button btn w-full btn--primary" name="commit" id="Newsletter-coupon">Copy Code</button></div>
    </div></form></div>
                  </div>
            <ul class="list-unstyled flex gap-x-4 gap-y-2 items-center socials flex-wrap justify-center" role="list"></ul>
            </div>
        </div>
      </div>
    </div>
  </subscription-popup>
        `;
        document.body.appendChild(infoPopup);

        const closeButton = document.getElementById('close-copupon-popup');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            console.log('closed')
            infoPopup.remove();
            localStorage.removeItem(this.submissionFlag); // Clear the submission flag
          });
        }
      }

      handleFormSubmission() {
        localStorage.setItem(this.submissionFlag, 'true');
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const subscriptionForm = document.querySelector('.subscription-popup__form form');
  if (subscriptionForm) {
    subscriptionForm.addEventListener('submit', () => {
      const subscriptionPopup = document.querySelector('subscription-popup');
      if (subscriptionPopup) {
        subscriptionPopup.handleFormSubmission();
      }
    });
  }
});